<template lang="pug">
  .onlineRevenueSlide.blue-background(ref="onlineRevSlide")
    .max-width-grid
      h4.white Holiday Season Online Retail Revenue (U.S. Holiday Season)<span class="super white"><a href="https://www.slideshare.net/adobe/adobe-digital-insights-holiday-recap-2018" target="_blank">3</a></span>
      .chart-wrapper
        chart
        .text-block.one
          p.p2.one 14.4%
          p.p2.two 14.7%
        .text-block.two(ref="highlightTxt")
          p.p2 increase YOY
        .text-block.three
          p.p2.one 2016
          p.p2.two 2017
          p.p2.three 2018
</template>

<script>
import Chart from '@/assets/img/barCharts/onlineRevenue.svg'
import { TimelineLite } from 'gsap'

export default {
  name: 'onlineRevenueSlide',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const getBars = this.$el.querySelectorAll('rect')
    const getHightlight = this.$el.querySelector('.highlight')
    const heights = [...getBars].map(el => el.getAttribute('height'))
    const yVal = [...getBars].map(el => el.getAttribute('y'))

    this.timeline = new TimelineLite({ paused: true })
   
    getBars.forEach((bar, i) => {
      let height = parseFloat(heights[i])
      let y = parseFloat(yVal[i])
      let animateFrom = height + y
      this.timeline
        .fromTo(bar, 1, {attr: { y: animateFrom, height: 0 } }, {attr:{ y: yVal[i], height: heights[i] } }, '-=0.75')
    })

    this.timeline
      .fromTo(getHightlight, 1, { opacity:0, y: 20 }, { opacity: 1, y: 0 }, '-=0.25')
      .fromTo(this.$refs.highlightTxt, 1, { opacity:0, y: 20 }, { opacity: 1, y: 0 }, '-=1.2')
  },
  computed: {
  },
  methods: {
    playAnimation () {
      this.timeline.seek(0)
      this.timeline.play()
    },
  },
  components: {
    Chart,
  },
}
</script>

<style scoped lang="scss">
.onlineRevenueSlide {
  height: 41rem;
  padding-top: 5rem;
  h4 {
    text-align: center;
    padding-bottom: 4.5rem;
  }

  .chart-wrapper {
    padding: 0 23.5%;
    position: relative;
  }

  .highlight {
    opacity: 0;
  }

  .text-block {
    .p2 {
      color: #fff;
      position: absolute;
    }

    &.one {
      top: 0;
      width: 100%;
      height: 100%;
      .p2 {
        &.one {
          left: 4%;
          top: 10%;
        }
        &.two {
          top: 1%;
          left: 21%;
        }
      }
    }

    &.two {
      left: 67.5%;
      top: 50%;
      width: 10%;
    }

    &.three {
      width: 100%;
      margin-top: .9rem;

      .p2 {
        &.one {
          left: 3%;
        }

        &.two {
          left: 19.5%;
        }

        &.three {
          left: 36.5%;
        }
      }
    }
  }

  @media #{$mobile} {
    h4 {
      padding-bottom: 3rem;
    }
    .chart-wrapper {
      padding: 0 19%;
    }

    .text-block {
      .p2 {
        color: #fff;
        position: absolute;
      }

      &.one {
        .p2 {
          &.one {
            left: 5%;
            top: 11%;
          }
          &.two {
            top: 2%;
            left: 24.5%;
          }
        }
      }

      &.two {
        left: 70.5%;
      }

      &.three {
        width: 100%;
        margin-top: .9rem;

        .p2 {
          &.one {
            left: 3%;
          }

          &.two {
            left: 22.5%;
          }

          &.three {
            left: 42%;
          }
        }
      }
    }
  }
}
</style>
